import {
  createProcessService,
  getProcessDetail,
  IdealProfileCompetences,
} from 'services/common/process/createProcess/create-process-service'

export function skippedCompetencesIdealProfile(skills: Array<{ id: number }>): IdealProfileCompetences[] {
  return skills.map(({ id }) => ({ skill_id: id, weight: 0 }))
}

export async function saveCompetencesIdealProfile(
  processId: number,
  competences: IdealProfileCompetences[]
): Promise<void> {
  if (!competences.length || competences.some(({ skill_id }) => !Number.isInteger(skill_id) || skill_id <= 0)) {
    throw new Error('Hay competencias inválidas en el perfil ideal. Revísalas antes de continuar.')
  }

  const saveResponse = await createProcessService({
    ideal_profile: {
      process_id: processId,
      competences_ideal_profile: competences,
    },
  }).catch(() => {
    throw new Error('No se pudo guardar el perfil ideal de 3D Skills. Inténtalo de nuevo.')
  })

  if (saveResponse.status !== 'OK') {
    if (saveResponse.errorCode === 'VALIDATION_ERROR') {
      throw new Error('Revisa las competencias y los puntajes mínimos del perfil ideal (de 0 a 100).')
    }
    if (
      [400, 409, 422].includes(saveResponse.httpStatus || 0) &&
      typeof saveResponse.error === 'string' &&
      saveResponse.error.trim()
    ) {
      throw new Error(saveResponse.error)
    }
    if (saveResponse.httpStatus === 401) {
      throw new Error('Tu sesión ha caducado. Inicia sesión de nuevo para guardar el perfil ideal.')
    }
    if (saveResponse.httpStatus === 403) {
      throw new Error('No tienes permiso para guardar este perfil ideal.')
    }
    if (saveResponse.httpStatus === 404) {
      throw new Error('No encontramos este proceso. Recarga la página y vuelve a intentarlo.')
    }
    if (saveResponse.networkError) {
      throw new Error('No se pudo conectar con el servidor. Comprueba tu conexión y vuelve a intentarlo.')
    }
    if ((saveResponse.httpStatus || 0) >= 500) {
      const reference =
        typeof saveResponse.traceId === 'string' && /^[a-z0-9-]{1,64}$/i.test(saveResponse.traceId)
          ? ` Referencia: ${saveResponse.traceId}.`
          : ''
      throw new Error(`No se pudo guardar el perfil ideal por un error del servidor.${reference} Inténtalo de nuevo.`)
    }
    throw new Error('No se pudo guardar el perfil ideal de 3D Skills. Inténtalo de nuevo.')
  }

  const detailResponse = await getProcessDetail(processId).catch(() => {
    throw new Error('No se pudo verificar el perfil ideal guardado. Inténtalo de nuevo.')
  })
  if (detailResponse.status !== 'OK') {
    throw new Error('No se pudo verificar el perfil ideal guardado. Inténtalo de nuevo.')
  }

  const savedProcess = (detailResponse as { process?: { competences_ideal_profile?: IdealProfileCompetences[] } }).process || detailResponse.data?.process
  const savedCompetences: IdealProfileCompetences[] = savedProcess?.competences_ideal_profile || []
  const matches =
    savedCompetences.length === competences.length &&
    competences.every((expected) =>
      savedCompetences.some(
        (saved) =>
          Number(saved.skill_id) === Number(expected.skill_id) &&
          (expected.weight === undefined || Number(saved.weight) === Number(expected.weight))
      )
    )

  if (!matches) {
    throw new Error('El perfil ideal de 3D Skills no quedó guardado como lo configuraste. Inténtalo de nuevo.')
  }
}
